module.exports = __webpack_public_path__ + "media/images/pic/courses/advanced-level-dbdf6eb34ee66aa8870107d7a4f73db3.png";